import React from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';

import { useAuthFunctions, useAuthState } from 'contexts/Auth';
import Logo from '../media/Logo';



const containerStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
};

const logoStyle = {
  width: '200px', // or any size you need
  height: '200px', // or any size you need
};

// style to put the modal in the middle of the screen
const modalStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export default function Splash() {
  const auth = useAuthFunctions()
  

  React.useEffect(() => {
    // console.log("loaded splash")
  }, [])
  return (
    <Paper style={containerStyle}>
      {/* <Favicon style={logoStyle} /> */}
      {/* <Logo style={logoStyle} /> ooh boy put that in a box */}
      <Box style={logoStyle}>
        <Logo />
      </Box>
      <Typography variant="h5" align="center">
        Thank you for your interest!
      </Typography>
      <Typography variant="h5" align="center">
        This is currently a beta and is not in active use. 
      </Typography>
      <Button
        onClick={auth.federatedLogin}
        variant="contained"
        color="primary"
        style={{ marginTop: '20px' }}
      >
        Sign In
      </Button>
      {/* <Button 
        onClick={() => setLoginModalOpen(true)}
        variant="contained" 
        color="primary">
            Sign In
        </Button> 
      <Modal
        style={modalStyle}
        open={loginModalOpen}
        onClose={() => setLoginModalOpen(false)}        
      >
        <div>
          <Login />
        </div>
      </Modal> */}
    </Paper>
  );
}
